import {
  Button,
  Col,
  Collapse,
  Descriptions,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Table,
} from 'antd';
import { Dropdown, InputGroup } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import CustomPagination from 'components/table/pagination';
import Excel from 'components/table/excel';
import CreateCancel from 'components/forms/CreateCancel';
import FormAccordion from 'components/forms/FormAccordion';
import InputNumber from 'components/inputs/InputNumber';
import InputControl from 'components/inputs/InputControl';
import InputControlAsync from 'components/inputs/InputControlAsync';
import DashboardContext from 'Context';
import PorfileWorker from './porfileWorker';
import FormWorker from './FormWorker';
import ChangeNumberForm from './ChangeNumberForm';
import InputControlMulti from 'components/inputs/InputControlMulti';
import toaster from 'helper/toaster';
import WorkerServicePoints from 'components/forms/contractualActions/WorkerServicePoints';

export default function Worker() {
  const {
    SohwaddFrom,
    urldashboard,
    authentication,
    accessPage,
    handelAdd,
    handelEdit,
    changeNumber,
    idview,
    handelIdview,
    handelerrors,
    handelloding,
  } = useContext(DashboardContext);

  // table data
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [record, setRecord] = useState({});
  const [headers, setHeaders] = useState([]);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [pointData, setPointData] = useState({
    positivePoints: [],
    negativePoints: [],
  });
  const [totalRecord, setTotalRecord] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  const [accordionsData, setAccordionsData] = useState([]);
  // action modals
  const [moreInfoModal, setMoreInfoModal] = useState(false);
  const [pointModal, setPointModal] = useState(false);
  const [serviceModal, setServiceModal] = useState(false);

  useEffect(() => {
    if (!moreInfoModal && !idview) {
      getWorkers({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        searchValue,
        formData,
      });
      setRecord({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handelAdd, idview, moreInfoModal]);

  const getWorkers = async ({ page, pageSize, searchValue, formData }) => {
    setLoading(true);
    try {
      let url = '/worker/get';
      const res = await Axios.post(
        urldashboard + url,
        JSON.stringify({ page, pageSize, search: searchValue, ...formData }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      setHeaders(data?.headers?.map((item) => item.label));
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getWorkers({
      page: newPage,
      pageSize: newPageSize,
      searchValue,
      formData,
    });
  };

  const search = () => {
    getWorkers({
      page: 1,
      pageSize: 10,
      searchValue,
      formData,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'عملیات',
      key: 'actions',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Dropdown>
          <Dropdown.Toggle
            style={{ backgroundColor: '#464dee', color: '#ffffff' }}
          ></Dropdown.Toggle>

          <Dropdown.Menu id={record?.id} align={'right'}>
            {accessPage?.includes('Update') && (
              <Dropdown.Item
                className={'d-inline-flex'}
                onClick={() => toDetails(record?.id)}
              >
                مشاهده جزئیات
              </Dropdown.Item>
            )}
            {accessPage?.includes('Update') && (
              <Dropdown.Item
                className={'d-inline-flex'}
                onClick={() => handleEditbtn(record?.id)}
              >
                ویرایش
              </Dropdown.Item>
            )}
            <Dropdown.Item
              className={'d-inline-flex'}
              onClick={() => handlePoint(record)}
            >
              ثبت امتیاز ویژه
            </Dropdown.Item>
            <Dropdown.Item
              className={'d-inline-flex'}
              onClick={() => handleService(record)}
            >
              نقطه سرویسهای نیرو
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
    {
      title: 'نام',
      dataIndex: 'firstName',
      key: 'firstName',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'نام خانوادگی',
      dataIndex: 'lastName',
      key: 'lastName',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'کد پرسنلی',
      dataIndex: 'personnelCode',
      key: 'personnelCode',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'کد پرسنلی پیوست',
      dataIndex: 'payvastPersonalCode',
      key: 'payvastPersonalCode',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'تاریخ شروع به کار',
      dataIndex: 'persianStartWork',
      key: 'persianStartWork',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ? value : '-'}</span>,
      // render: (date) => <span>{date?.format('jYYYY/jM/jD')}</span>,
    },
    {
      title: 'شماره تلفن ثابت',
      dataIndex: 'tell',
      key: 'tell',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'شماره تلفن همراه',
      dataIndex: 'cellPhone',
      key: 'cellPhone',
      responsive: ['xl', 'lg', 'md', 'sm'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'وضعیت',
      dataIndex: 'isActive',
      key: 'isActive',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ? 'فعال' : 'غیرفعال'}</span>,
    },
    {
      title: 'خوابگاه',
      dataIndex: 'dormName',
      key: 'dormName',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'اطلاعات بیشتر',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => showInfoModal(record)}>
          <i className='mdi mdi-eye'></i>
        </Button>
      ),
    },
  ];

  // actions

  const showInfoModal = (data) => {
    setRecord(data);
    setMoreInfoModal(true);
  };

  const handleEditbtn = (id) => {
    handelAdd(true);
    handelEdit(id);
  };

  const handlePoint = (data) => {
    setRecord(data);
    setPointModal(true);
  };

  const handleService = (data) => {
    setRecord(data);
    setServiceModal(true);
  };

  const toDetails = (id) => {
    handelIdview(id);
    handelloding(true);
  };

  const handleAccordion = (arry) => {
    if (arry.length > 0) {
      const flatArry = arry.flat();
      setAccordionsData(flatArry);
    }
  };

  useEffect(() => {
    setFormData({ ...formData, specificationValueIds: accordionsData });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accordionsData]);

  const handleSubmit = async () => {
    if (
      pointData?.positivePoints?.length < 1 &&
      pointData?.negativePoints?.length < 1
    )
      return toaster.error('حداقل یک مورد را انتخاب کنید.');

    setSubmitLoading(true);
    try {
      let url = '/worker/setPoint';

      const response = await Axios.post(
        urldashboard + url,
        {
          workerId: record?.id,
          description: pointData?.description,
          disciplineIds: [
            ...pointData?.positivePoints,
            ...pointData?.negativePoints,
          ],
        },
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json; charset=utf-8',
          },
        }
      );
      toaster.success(response?.data?.message);
      setSubmitLoading(false);
      setPointModal(false);
      setPointData({});
      setRecord({});
    } catch (error) {
      handelerrors(error);
      setSubmitLoading(false);
    }
  };

  return (
    <>
      <CreateCancel />

      {SohwaddFrom ? (
        <div
          style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '15px',
          }}
        >
          {changeNumber ? <ChangeNumberForm mustRefetch /> : <FormWorker />}
        </div>
      ) : idview ? (
        <PorfileWorker />
      ) : (
        <>
          <div style={{ display: 'flex' }}>
            <div style={{ flex: 1 }}>
              <Collapse defaultActiveKey={['0']}>
                <Collapse.Panel header='جستجو پیشرفته' key='1'>
                  {/* */}
                  <Row gutter={20}>
                    <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                      <InputControl
                        isMulti
                        url={
                          formData?.profileBusinessType?.toString()
                            ? `/category/dropdown/${formData?.profileBusinessType}`
                            : '/category/dropdown'
                        }
                        label='گروه اصلی خدمات'
                        name='categoryIds'
                        handelValue={(_, value) =>
                          setFormData({ ...formData, categoryIds: value })
                        }
                      />
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                      <InputControl
                        url='/group/groupDropdown'
                        label='دسته خدمات'
                        name='groupId'
                        handelValue={(_, value) =>
                          setFormData({ ...formData, groupId: value })
                        }
                      />
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                      <InputControl
                        url='/common/genderdropdown'
                        label='جنسیت'
                        name='gender'
                        handelValue={(_, value) =>
                          setFormData({ ...formData, gender: value })
                        }
                      />
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                      <InputControl
                        url='/dorm/dropdown'
                        label='خوابگاه'
                        name='dormId'
                        handelValue={(_, value) =>
                          setFormData({ ...formData, dormId: value })
                        }
                      />
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                      <InputControl
                        url='/common/profilebusinesstypedropdown'
                        label='نوع بیزینس کار نیرو'
                        name='profileBusinessType'
                        handelValue={(_, value) =>
                          setFormData({
                            ...formData,
                            profileBusinessType: value,
                          })
                        }
                      />
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                      <InputControl
                        url='/common/committedType'
                        label='نوع تعهد'
                        name='committedType'
                        handelValue={(_, value) =>
                          setFormData({
                            ...formData,
                            committedType: value,
                          })
                        }
                      />
                    </Col>
                  </Row>
                  {/* */}
                  <Row gutter={20}>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                      <InputControlAsync
                        url='/worker/search'
                        label='انتخاب نیرو'
                        name='workerId'
                        handelValue={(_, value) =>
                          setFormData({ ...formData, workerId: value })
                        }
                      />
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                      <InputNumber
                        label='شماره موبایل'
                        name='cellPhone'
                        handelValue={(_, value) =>
                          setFormData({ ...formData, cellPhone: value })
                        }
                      />
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                      <InputControl
                        url='/common/appStatusDropdown'
                        label='وضعیت اپلیکیشن'
                        name='appStatus'
                        handelValue={(_, value) =>
                          setFormData({ ...formData, appStatus: value })
                        }
                      />
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                      <InputControl
                        url='/common/workerstatustypedropdown'
                        label='وضعیت نیرو'
                        name='workerStatusType'
                        handelValue={(_, value) =>
                          setFormData({ ...formData, workerStatusType: value })
                        }
                      />
                    </Col>
                  </Row>
                  {/* */}
                  <Row gutter={20}>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                      <InputControl
                        url='/common/workertypedropdown'
                        label='نوع نیرو'
                        name='workerType'
                        handelValue={(_, value) =>
                          setFormData({ ...formData, workerType: value })
                        }
                      />
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                      <InputControl
                        url='/common/getWorkType'
                        label='نوع کار نیرو'
                        name='workType'
                        handelValue={(_, value) =>
                          setFormData({
                            ...formData,
                            workType: value,
                          })
                        }
                      />
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                      <InputControl
                        url='/common/vipstatusdropdown'
                        label='وضعیتVIP نیرو'
                        name='vipStatus'
                        handelValue={(_, value) =>
                          setFormData({
                            ...formData,
                            vipStatus: value,
                          })
                        }
                      />
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                      <InputControl
                        url='/workerInsuranceReport/hasInsuranceTypeTypeDropdown'
                        label='وضعیت بیمه'
                        name='hasInsuranceType'
                        handelValue={(_, value) =>
                          setFormData({ ...formData, hasInsuranceType: value })
                        }
                      />
                    </Col>
                    <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                      <InputNumber
                        label='کد پرسنلی پیوست'
                        name='payvastPersonalCode'
                        handelValue={(_, value) =>
                          setFormData({
                            ...formData,
                            payvastPersonalCode: value,
                          })
                        }
                      />
                    </Col>
                  </Row>
                  {/* */}
                  <Row gutter={20}>
                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                      <FormAccordion
                        urldata='worker/specificationvaluedropdown'
                        handelAccordion={handleAccordion}
                        formvalueAccordion={accordionsData}
                      />
                    </Col>
                  </Row>
                  {/* */}
                  <Row
                    gutter={20}
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginTop: 20,
                    }}
                  >
                    <Col xl={5} lg={5} md={24} sm={24} xs={24}>
                      <Button
                        type='primary'
                        style={{ width: '100%' }}
                        loading={loading}
                        onClick={() => search()}
                      >
                        جستجو
                      </Button>
                    </Col>
                  </Row>
                </Collapse.Panel>
              </Collapse>
            </div>
          </div>

          <Row
            gutter={20}
            style={{
              marginTop: 25,
            }}
          >
            <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
              <Form form={form} layout='vertical' onFinish={search}>
                <InputGroup>
                  <Input
                    placeholder='جستجوی سریع (نام نیرو یا کد پرسنلی)'
                    name='searchValue'
                    onChange={(e) => setSearchValue(e.target.value)}
                    style={{
                      height: '3rem',
                      width: '90%',
                      display: 'table-cell',
                    }}
                  />
                  <Button
                    htmlType='submit'
                    style={{
                      height: '3rem',
                      width: '10%',
                      display: 'table-cell',
                      padding: 0,
                    }}
                  >
                    <i className='mdi mdi-magnify'></i>
                  </Button>
                </InputGroup>
              </Form>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
              <Space
                wrap
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%',
                }}
              >
                <Excel data={data} headers={headers} fileName={'سفارشات'} />
              </Space>
            </Col>
          </Row>

          <Table
            size='small'
            style={{ textAlign: 'right', marginTop: 10 }}
            rowClassName={() => 'center'}
            columns={columns}
            bordered={true}
            dataSource={data}
            loading={loading}
            pagination={false}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />

          {!loading && (
            <CustomPagination
              totalRecord={totalRecord}
              pagination={pagination}
              handlePagination={handlePagination}
            />
          )}

          {serviceModal && (
            <WorkerServicePoints
              openModal={serviceModal}
              isWorker
              id={record?.id}
              close={() => setServiceModal(false)}
            />
          )}

          <Modal
            title='ثبت امتیاز ویژه'
            closable={false}
            open={pointModal}
            destroyOnClose
            onCancel={() => {
              setPointModal(false);
              setPointData({});
              setRecord({});
            }}
            footer={[
              <Button
                type='primary'
                className='confirmation-address'
                onClick={() => handleSubmit()}
                loading={submitLoading}
              >
                ثبت
              </Button>,
            ]}
            bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
          >
            <Space direction='vertical' style={{ width: '100%' }}>
              <InputControlMulti
                url='/discipline/dropdown/2'
                label='موارد تشویقی'
                name='positivePoints'
                handelValue={(_, value) =>
                  setPointData({ ...pointData, positivePoints: value })
                }
              />
              <InputControlMulti
                url='/discipline/dropdown/1'
                label='موارد تخلفی'
                name='negativePoints'
                handelValue={(_, value) =>
                  setPointData({ ...pointData, negativePoints: value })
                }
              />
              <div className='form-group'>
                <label htmlFor='description'>توضیحات کارشناس</label>
                <textarea
                  className='form-control'
                  id='description'
                  rows='6'
                  onChange={(e) =>
                    setPointData({ ...pointData, description: e.target.value })
                  }
                ></textarea>
              </div>
            </Space>
          </Modal>

          <Modal
            title='اطلاعات بیشتر'
            closable={false}
            open={moreInfoModal}
            onCancel={() => setMoreInfoModal(false)}
            footer={[
              <Button key='back' onClick={() => setMoreInfoModal(false)}>
                بستن
              </Button>,
            ]}
            bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
          >
            <Descriptions bordered column={1} size={'small'}>
              <Descriptions.Item label='نام'>
                {record?.firstName ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='نام خانوادگی'>
                {record?.lastName ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='نوع تعهد'>
                {record?.committedTypeTitle ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='کد پرسنلی'>
                {record?.personnelCode ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='کد پرسنلی پیوست'>
                {record?.payvastPersonalCode ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='تاریخ شروع به کار'>
                {record?.persianStartWork
                  ? record?.persianStartWork
                  : 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='تلفن ثابت'>
                {record?.tell ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='تلفن همراه'>
                {record?.cellPhone ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='آیا نیرو فعال است؟'>
                {record?.isActive ? 'بله' : 'خیر'}
              </Descriptions.Item>
              <Descriptions.Item label='نام خوابگاه'>
                {record?.dormName ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='کد ملی'>
                {record?.nationalCode ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='تاریخ تولد'>
                {record?.persainBirthDate
                  ? record?.persainBirthDate
                  : 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='گروه اصلی'>
                {record?.categoryTitle ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='شهر محل سکونت'>
                {record?.cityName ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='شماره کارت بانکی'>
                {record?.debitCardNumber ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='شماره شبا'>
                {record?.shebaCode ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='تاریخ آخرین غیرفعال بودن'>
                {record?.persianInactiveDate
                  ? record?.persianInactiveDate
                  : 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='تاریخ شروع اعمال امتیاز'>
                {record?.persianRateStartDate
                  ? record?.persianRateStartDate
                  : 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='مبلغ ضمانت (ریال)'>
                {record?.warrantyAmount
                  ? record?.warrantyAmount?.toLocaleString()
                  : 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='نوع نیرو'>
                {record?.workerTypeTitle ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='نوع موبایل'>
                {record?.mobileTypeTitle ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='بیزینس نیرو'>
                {record?.profileBusinessTypeTitle ?? 'اطلاعات وارد نشده'}
              </Descriptions.Item>
              <Descriptions.Item label='آیا در لیست سیاه مالی است؟'>
                {record?.isBlackListed ? 'بله' : 'خیر'}
              </Descriptions.Item>
              <Descriptions.Item label='آیا در لیست سیاه انضباطی است؟'>
                {record?.hasDiscipline ? 'بله' : 'خیر'}
              </Descriptions.Item>
              <Descriptions.Item label='آیا نیروی VIP است؟'>
                {record?.isVip ? 'بله' : 'خیر'}
              </Descriptions.Item>
              <Descriptions.Item label='آیا فعال است؟'>
                {record?.isReady ? 'بله' : 'خیر'}
              </Descriptions.Item>
              <Descriptions.Item label='آیا اپلیکیشن فعال است؟'>
                {record?.isReady ? 'بله' : 'خیر'}
              </Descriptions.Item>
              <Descriptions.Item label='امتیاز'>
                {record?.showPoints}
              </Descriptions.Item>
              <Descriptions.Item label='شرایط انجام کار'>
                {record?.workerSpecificationValues
                  ? record?.workerSpecificationValues
                  : 'اطلاعات وارد نشده'}
              </Descriptions.Item>
            </Descriptions>
          </Modal>
        </>
      )}
    </>
  );
}
